import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { BACKEND_APIS } from "@constants"


export default function AppPriceChangeComparisonAlertAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
        label="Price change comparison alert"
        placeholder="Select price change comparison alert"
        urlAjax={`${BACKEND_APIS.CRUD}/user/price_changes_comparison?selectorFormat=true`}
        {...props}
    />
}